import React, {
  useCallback,
  useEffect,
  useState,
  useRef,
  useMemo,
} from 'react';
import { toast } from 'react-toastify';

import { IconButton, Button } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { isArray, isEmpty } from 'lodash';
import qs from 'querystring';

import { Table } from '~/components';
import api from '~/services/api';

import GravarDialog from './GravarDialog';
import * as S from './styles';
import ValidarDialog from './ValidarDialog';

export default function PlanilhaAdm(props) {
  const reference = useRef(null);
  const [planilhaClienteErro, setPlanilhaClienteErro] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [myFiles, setMyFiles] = useState([]);
  const [initials, setInitials] = useState({});
  const [sending, setSending] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [statusValidar, setStatusValidar] = useState(false);
  const [statusGravar, setStatusGravar] = useState(true);

  const [statusComErroValidacao, setStatusComErroValidacao] = useState(true);
  const [
    tituloConfirmationDialogRaw,
    setTituloConfirmationDialogRaw,
  ] = React.useState('VOCÊ CONFIRMA VALIDAR!');
  const [
    mensagemConfirmationDialogRaw,
    setMensagemConfirmationDialogRaw,
  ] = React.useState('Deseja confirmar a operação?');
  const [
    openConfirmationDialogRaw,
    setOpenConfirmationDialogRaw,
  ] = React.useState(false);
  const [
    valueConfirmationDialogRaw,
    setValueConfirmationDialogRaw,
  ] = React.useState('CLICK-OK');

  const [
    tituloConfirmationDialogGravarRaw,
    setTituloConfirmationDialogGravarRaw,
  ] = React.useState('VOCÊ CONFIRMA GRAVAR!');
  const [
    mensagemConfirmationDialogGravarRaw,
    setMensagemConfirmationDialogGravarRaw,
  ] = React.useState('Deseja confirmar a operação?');
  const [
    openConfirmationDialogGravarRaw,
    setOpenConfirmationDialogGravarRaw,
  ] = React.useState(false);
  const [
    valueConfirmationDialogGravarRaw,
    setValueConfirmationDialogGravarRaw,
  ] = React.useState('CLICK-OK');

  const handleOk = async () => {
    setSending(true);
  };

  const handleConfirmationDialog = async () => {
    setOpenConfirmationDialogRaw(true);
  };

  const handleConfirmationDialogGravar = async () => {
    setOpenConfirmationDialogGravarRaw(true);
  };

  const handleCancelar = async () => {
    props.setArquivoProcessar('');
  };

  const cellsHeader = useMemo(
    () => [
      { id: 'planilha', label: 'Planilha' },
      { id: 'campo', label: 'Campo' },
      { id: 'linha', label: 'Linha' },
      { id: 'erro', label: 'Erro' },
    ],
    []
  );

  const execHandleValidar = async (param) => {
    try {
      const wherefield = [];
      const valuewherefield = [];
      const typewherefield = [];
      wherefield.push('');
      valuewherefield.push('');
      typewherefield.push('');
      const search = { wherefield, valuewherefield, typewherefield };
      const { data } = await api.get('/uploadplanilhacliente/validar', {
        params: { ...search, pagesize: 99999, pesquisalista: true, page: 1 },
        paramsSerializer: (param) => qs.stringify(param),
      });
      const { items } = data;

      if (!isEmpty(items)) {
        toast.error('Processo passou aqui!');
      } else {
        toast.error('Falha no processo!');
      }
    } catch (err) {
      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }
    }
  };

  const handleConfirmationDialogRaw = (recordResultDialog) => {
    // console.log(newValue);
    setOpenConfirmationDialogRaw(false);
    if (recordResultDialog) {
      setValueConfirmationDialogRaw(recordResultDialog.acao);
      setIsLoading(false);
      if (recordResultDialog.acao === 'CLICK-OK') {
        // handleSubmitConfirmar();
        setIsLoading(true);

        setStatusValidar(true);
        setStatusGravar(false);
        // handleSubmit(paramSubmit, recordResultDialog)
      }
    } else {
      // cancelarAcao();
      setStatusValidar(false);
      setStatusGravar(true);
      setIsLoading(false);
    }
  };

  const handleConfirmationDialogGravarRaw = (recordResultDialog) => {
    // console.log(newValue);
    setOpenConfirmationDialogGravarRaw(false);
    if (recordResultDialog) {
      setValueConfirmationDialogGravarRaw(recordResultDialog.acao);
      setIsLoading(false);
      if (recordResultDialog.acao === 'CLICK-OK') {
        // handleSubmitConfirmar();
        setIsLoading(true);
        setStatusValidar(true);
        setStatusGravar(true);
        props.setArquivoProcessar('');
        // handleSubmit(paramSubmit, recordResultDialog)
      }
    } else {
      // cancelarAcao();
      setStatusValidar(false);
      setStatusGravar(true);
      setIsLoading(false);
    }
  };

  const imprimir = () => {
    window.print(); // Esta função abre a janela de impressão do navegador
  };

  // Função para imprimir apenas a tabela
  // const imprimirTabela = () => {
  //   const conteudo = document.getElementById('tabela'); // Seleciona a tabela
  //   const novaJanela = window.open('/uploadplanilhacliente', '_blank', 'height=600, width=800');
  //   // Adiciona o conteúdo da tabela na nova janela
  //   novaJanela.document.write('<html><head><title>Imprimir Tabela</title></head><body>');
  //   novaJanela.document.write(conteudo.outerHTML); // Adiciona a tabela na nova janela
  //   novaJanela.document.write('</body></html>');
  //   novaJanela.document.close(); // Fecha o documento da nova janela
  //   novaJanela.print(); // Chama o método de impressão
  //   setTimeout(() => {
  //     window.location.reload();
  //     novaJanela.close(); // Tenta fechar a janela após a impressão
  //   }, 3000);  // A janela será fechada após 3 segundos
  // };

  return (
    <>
      <>
        {' '}
        {/* <> Para confirmação do form */}
        <ValidarDialog
          id="ringtone-menu-confirmar"
          keepMounted
          modal="md"
          open={openConfirmationDialogRaw}
          onClose={handleConfirmationDialogRaw}
          valueProp={valueConfirmationDialogRaw}
          mensagem={mensagemConfirmationDialogRaw}
          titulo={tituloConfirmationDialogRaw}
          textoBtnOK="Validar Agora"
          textoBtnCancel="Cancelar"
          arquivo={props.arquivoProcessar}
          setStatusComErroValidacao={setStatusComErroValidacao}
          setPlanilhaClienteErro={setPlanilhaClienteErro}
        />
      </>{' '}
      {/* <> Para confirmação do form */}
      <>
        {' '}
        {/* <> Para confirmação do form */}
        <GravarDialog
          id="ringtone-menu-confirmar"
          keepMounted
          modal="md"
          open={openConfirmationDialogGravarRaw}
          onClose={handleConfirmationDialogGravarRaw}
          valueProp={valueConfirmationDialogGravarRaw}
          mensagem={mensagemConfirmationDialogGravarRaw}
          titulo={tituloConfirmationDialogGravarRaw}
          textoBtnOK="Gravar Agora"
          arquivo={props.arquivoProcessar}
          textoBtnCancel="Cancelar"
        />
      </>{' '}
      {/* <> Para confirmação do form */}
      <S.FormWrapper ref={reference} initialData={initials}>
        <S.Wrapper>
          <S.Container>
            <S.ContainerButton>
              <Button
                color="primary"
                variant="contained"
                type="button"
                onClick={handleConfirmationDialog}
                disabled={statusValidar}
              >
                Validar Planilha
              </Button>

              <Button
                color="primary"
                variant="contained"
                type="button"
                onClick={handleConfirmationDialogGravar}
                disabled={statusGravar}
              >
                Gravar
              </Button>

              <Button
                color="primary"
                variant="contained"
                type="button"
                onClick={handleCancelar}
              >
                Cancelar
              </Button>
            </S.ContainerButton>

            <div className="container" style={{ marginBottom: '20px' }}>
              <h6>{props.arquivoProcessar}</h6>
            </div>

            {/* <button onClick={imprimirTabela}>Imprimir Tabela</button> */}

            <S.ContainerStatus id="tabela">
              <span>Erros</span>

              <Table
                size="small"
                cells={cellsHeader}
                data={planilhaClienteErro}
                loading={loading}
                paginate={99999}
                maxHeight={900}
                showPagination={false}
              />
              <span>Total de registros: {planilhaClienteErro.length}</span>
            </S.ContainerStatus>
          </S.Container>
        </S.Wrapper>
      </S.FormWrapper>
    </>
  );
}
